import { render, staticRenderFns } from "./media-field.vue?vue&type=template&id=f1bf2aba&"
import script from "./media-field.vue?vue&type=script&lang=js&"
export * from "./media-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports